var BusStopState;
(function (BusStopState) {
    // No icon to show - this state is for item parts before the start or after the end of the bus line.
    BusStopState[BusStopState["None"] = 0] = "None";
    // Start of the bus line. This is currently a line extending down from a checkmark. Represented visually by:
    BusStopState[BusStopState["BusStart"] = 1] = "BusStart";
    // End of the bus line. Represented visually by:
    BusStopState[BusStopState["BusEnd"] = 2] = "BusEnd";
    // This is a bus stop between the start and end of the bus line. Represented visually by:
    BusStopState[BusStopState["BusStop"] = 3] = "BusStop";
    // This is not a bus stop, but the node is between the start and end of the bus. Represented visually by:
    BusStopState[BusStopState["NoStop"] = 4] = "NoStop";
    // This is the case where the selected item has no parent node. We just want to show a single check mark
    // with no bus lines.
    BusStopState[BusStopState["CheckMark"] = 5] = "CheckMark";
})(BusStopState || (BusStopState = {}));
export default BusStopState;
//# sourceMappingURL=BusStopState.js.map